import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Styles} from "../../../../../config/design/styles";
import { withSnackbar } from 'notistack';
import {connect} from "trim-redux";
import FileManagerDialog from "../../../fileManager/Components/FileManagerDialog";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import {Translate} from "../../../../../config/Translate";
import Button from "@material-ui/core/Button/Button";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import GetConfirmationText from "../../../../components/elements/GetConfirmationText";
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import {withRouter} from "react-router-dom";

class SendFileInChatButton extends React.Component{

    classes = this.props.classes;
    handleCloseTicket(){
        let {id} = this.props;
        let {manage} = this.props;
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/ticket/close`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.ticketClosed, {
                    variant: 'info',
                });
                if(manage){
                    this.props.history.push('/manage/tickets');
                }else{
                    this.props.history.push('/tickets');
                }
            })
            .catch(error => {
                console.log(error.response);
                this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                    variant: 'error',
                });
            });
    }
    render(){
        return (
            <>
                <GetConfirmationText
                    tooltip={Translate.closeTicket}
                    className={this.classes.link}
                    style={{
                        cursor:"pointer",
                        color: this.props.primary_color,
                        marginBottom:0,
                        border: "1px solid #3887bf",
                        padding: "5px 8px",
                        borderRadius: 6
                    }}
                    size="small"
                    handleAction={() => this.handleCloseTicket()}
                    icon={<CheckBoxIcon/>}
                    color={this.props.primary_color}
                >
                    {Translate.closeTicket}
                </GetConfirmationText>
            </>
        );
    }
}

const mstp = state => ({
    Translate: state.Translate,
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(SendFileInChatButton))));